<div class="pointer-events-none invisible w-0">
  <ng-content></ng-content>
</div>
